(function () {
  'use strict';
  var loader = document.currentScript;
  if (!loader || loader.id !== 'dl-source-capture' || window.__dlSourceCaptureV1) return;
  if (location.hostname.replace(/^www\./, '') !== 'dreamlikecurtains.com') return;
  window.__dlSourceCaptureV1 = true;
  var storageKey = 'dl_source_v1';
  var maxAge = 30 * 60 * 1000;
  var sourceKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid'];
  var outputKeys = ['touch_id'].concat(sourceKeys, ['original_landing_url', 'original_referrer', 'consent_state']);
  var markerStart = '[DL_SOURCE_BEGIN]';
  var markerEnd = '[DL_SOURCE_END]';
  var attached = new WeakSet();
  var consentTimers = [];
  function permission() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.currentVisitorConsent !== 'function' || typeof api.marketingAllowed !== 'function') return 'unknown';
      var consent = api.currentVisitorConsent();
      if (consent.marketing === 'no') return 'denied';
      if (consent.marketing !== 'yes') return 'unknown';
      var allowed = api.marketingAllowed();
      return allowed === true ? 'allowed' : allowed === false ? 'denied' : 'unknown';
    } catch (ignore) { return 'unknown'; }
  }
  function clear() {
    try { localStorage.removeItem(storageKey); } catch (ignore) {}
  }
  function read() {
    try {
      var snapshot = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (!snapshot || snapshot.version !== 1 || typeof snapshot.captured_at !== 'number' || Date.now() - snapshot.captured_at < 0 || Date.now() - snapshot.captured_at > maxAge || snapshot.consent_state !== 'allowed') return null;
      if (!/^DLT-[0-9a-f-]{36}$/.test(snapshot.touch_id || '')) return null;
      return snapshot;
    } catch (ignore) { return null; }
  }
  function clean(value) {
    if (!value || value.length > 1024 || /[\r\n<>]/.test(value) || /@|%40/i.test(value)) return '';
    return value;
  }
  function refresh() {
    var state = permission();
    if (state === 'denied') { clear(); return null; }
    if (state !== 'allowed') return null;
    var saved = read();
    if (saved) return saved;
    clear();
    var url = new URL(location.href);
    var values = {};
    sourceKeys.forEach(function (key) { var value = clean(url.searchParams.get(key)); if (value) values[key] = value; });
    if (!Object.keys(values).length) return null;
    if (!window.crypto || typeof crypto.randomUUID !== 'function') return null;
    var safeUrl = new URL(url.origin + url.pathname);
    sourceKeys.forEach(function (key) { if (values[key]) safeUrl.searchParams.set(key, values[key]); });
    var snapshot = Object.assign({version: 1, captured_at: Date.now(), touch_id: 'DLT-' + crypto.randomUUID()}, values, {original_landing_url: safeUrl.href, consent_state: state});
    try {
      if (document.referrer) {
        var referrer = new URL(document.referrer);
        if (/^https?:$/.test(referrer.protocol) && referrer.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) {
          snapshot.original_referrer = referrer.origin + '/';
        }
      }
    } catch (ignore) {}
    try { localStorage.setItem(storageKey, JSON.stringify(snapshot)); }
    catch (ignore) { return null; }
    return snapshot;
  }
  function attach() {
    document.querySelectorAll('form[data-id="162965"]').forEach(function (form) {
      if (attached.has(form) || form.getAttribute('action') !== 'https://app.powerfulform.com/api/front/form/162965/send') return;
      attached.add(form);
      form.addEventListener('formdata', function (event) {
        try {
          var snapshot = refresh();
          if (!snapshot || permission() !== 'allowed') return;
          var data = event.formData;
          var original = data.get('textarea');
          if (typeof original !== 'string') return;
          var lines = outputKeys.filter(function (key) { return key === 'consent_state' || typeof snapshot[key] === 'string' && snapshot[key] !== ''; }).map(function (key) { return key + '=' + JSON.stringify(snapshot[key]); });
          var block = markerStart + '\n' + lines.join('\n') + '\n' + markerEnd;
          if (!original.endsWith(block)) data.set('textarea', original + '\n\n' + block);
        } catch (ignore) {}
      });
    });
  }
  function settleConsent() {
    consentTimers.forEach(clearTimeout);
    consentTimers = [0, 100, 400, 1000, 2500, 5000, 10000].map(function (delay) {
      return setTimeout(refresh, delay);
    });
  }
  refresh();
  document.addEventListener('visitorConsentCollected', function () { refresh(); settleConsent(); });
  document.addEventListener('trackingConsentAccepted', function () { refresh(); settleConsent(); });
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('#m-cookie-banner .cookie-action--accept, #m-cookie-banner .cookie-action--decline')) settleConsent();
  });
  window.addEventListener('pageshow', settleConsent);
  settleConsent();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); attach(); }, {once: true});
  else attach();
  new MutationObserver(attach).observe(document.documentElement, {childList: true, subtree: true});
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) { refresh(); settleConsent(); } });
  }
}());
